import { Box, Button, Grid, Typography } from '@mui/material'
import { styled } from '@mui/system'
import { LINK_SUPPORT } from 'config'

const RootContainer = styled(Box)({
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
  marginRight: 'auto',
  marginLeft: 'auto',
})

const GridContainer = styled(Grid)({
  height: '100vh',
})

const Content = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: '#fff',
  color: '#888888',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
}))

const Instruction = styled(Grid)(() => ({
  minHeight: '280px',
  overflow: 'hidden',
  fontSize: '16px',
  lineHeight: '1.7em',
  letterSpacing: '0.02em',
  position: 'relative',
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
}))

const InstructionTitle = styled(Typography)(() => ({
  fontSize: '24px',
  fontWeight: '500',
  marginBottom: '30px',
}))

const InstructionBody = styled(Typography)(() => ({
  marginTop: '28px',
  marginBottom: '1rem',
}))

const BtnSecondary = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 550,
  marginTop: '20px',
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: 'rgb(5, 214, 134)',
  borderColor: 'rgb(5, 214, 134)',
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: 'rgb(5, 214, 134)',
    borderColor: 'rgb(5, 214, 134)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#0062cc',
    borderColor: '#005cbf',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
})

const ConcurLoginFailure: React.FC = () => {
  const toSupportPage = () => {
    window.location.href = LINK_SUPPORT
  }

  return (
    <RootContainer>
      <GridContainer container>
        <Content item sm={12} xl={12}>
          <Instruction item lg={6} xl={5}>
            <InstructionTitle variant="h3">
              Concur Invoiceとの接続ができませんでした。
            </InstructionTitle>
            <InstructionBody variant="body1">
              すでに、Concur InvoiceとOCR
              Readerとの連携を申込み済みの場合は営業担当者までお問い合わせください。まだ、申込みをされていない場合は
              こちらからお問い合わせしてください。
            </InstructionBody>
            <BtnSecondary variant="contained" disableRipple onClick={toSupportPage}>
              お問い合わせ
            </BtnSecondary>
          </Instruction>
        </Content>
      </GridContainer>
    </RootContainer>
  )
}

export default ConcurLoginFailure
